module.exports = __webpack_public_path__ + "static/media/sura-logo.4d92ebdc.svg";